import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mainImage", "mainVideo", "thumbnail", "videoThumbnail"]

  connect() {
    this.currentIndex = 0
  }

  disconnect() {
    // Cleanup
  }

  select(event) {
    const index = parseInt(event.currentTarget.dataset.index)
    this.currentIndex = index

    // Get the clicked thumbnail
    const thumbnails = this.thumbnailTargets
    const videoThumbnails = this.videoThumbnailTargets

    // Find if it's an image or video
    const thumbnail = thumbnails.find(t => t.closest('[data-index]')?.dataset.index == index)
    const videoThumbnail = videoThumbnails.find(t => t.closest('[data-index]')?.dataset.index == index)

    if (thumbnail) {
      this.showImage(thumbnail.dataset.src)
    } else if (videoThumbnail) {
      this.showVideo(videoThumbnail.dataset.src)
    }
  }

  showImage(src) {
    // Hide video if present
    if (this.hasMainVideoTarget) {
      this.mainVideoTarget.classList.add("hidden")
      this.mainVideoTarget.pause()
    }

    // Show and update image
    if (this.hasMainImageTarget) {
      this.mainImageTarget.classList.remove("hidden")
      this.mainImageTarget.src = src
    } else {
      // Create image if it doesn't exist
      const panel = document.getElementById("main-media-panel")
      if (panel) {
        panel.innerHTML = `<img src="${src}" class="h-full w-full object-cover object-center sm:rounded-lg" data-media-gallery-target="mainImage" data-image-zoom-target="image">`
      }
    }
  }

  showVideo(src) {
    // Hide image if present
    if (this.hasMainImageTarget) {
      this.mainImageTarget.classList.add("hidden")
    }

    // Show and update video
    if (this.hasMainVideoTarget) {
      this.mainVideoTarget.classList.remove("hidden")
      const source = this.mainVideoTarget.querySelector("source")
      if (source && source.src !== src) {
        source.src = src
        this.mainVideoTarget.load()
      }
      this.mainVideoTarget.play()
    } else {
      // Create video if it doesn't exist
      const panel = document.getElementById("main-media-panel")
      if (panel) {
        panel.innerHTML = `
          <video controls class="h-full w-full object-cover object-center sm:rounded-lg" data-media-gallery-target="mainVideo" autoplay>
            <source src="${src}" type="video/mp4">
          </video>
        `
      }
    }
  }
}
